module.exports = __webpack_public_path__ + "static/media/manguera-roja.9a7ee7f9.svg";